import React from "react";
import {
  Container,
  Grid,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import {
  WorldIcon,
  ServiceImage1,
  ServiceImage2,
  ServiceImage3,
  ServiceImage4,
  ServiceImage5
} from "../../constant";
import SustainableImage from "../Imgeview";
import HoverImageCard from "../imageview2";
import AnimatedTextCard from "../ImageView3";

export default function ServicesHero() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const cardsData = [
    { id: 1, imageSrc: ServiceImage1 ,title:"Smarter Operational Control", subTitle:"Gain greater visibility, faster decision-making, and streamlined execution across critical business operations." },
    { id: 2, imageSrc: ServiceImage2 ,title:"Sustainable Performance at Scale", subTitle:"Improve environmental performance, strengthen accountability, and accelerate enterprise sustainability objectives with confidence."},
    { id: 3, imageSrc: ServiceImage3 ,title:"Execution-Driven Partnership",subTitle:"Work with a team that understands operational complexity, industrial environments, and enterprise-scale transformation."},
    { id: 4, imageSrc: ServiceImage4,title:"Enterprise-Wide Governance", subTitle:"Standardize processes, improve oversight, and strengthen compliance across distributed operations and teams." },
    { id: 5, imageSrc: WorldIcon ,title:"Transformation That Creates Business Impact", subTitle:"Helping enterprises reduce inefficiencies, improve resilience, optimize resources, and build future-ready operations with practical, scalable solutions."},
    { id: 6, imageSrc: ServiceImage5 ,title:"Operational Excellence", subTitle:"Enable consistent performance, stronger coordination, and continuous improvement across people, processes, and operations." },
  ];

  return (
    <Container
      sx={{
        maxWidth: isMobile ? "100%" : isTablet ? "90%" : "100%",
        px: isMobile ? 1 : 2,
      }}
    >
      <Grid container spacing={isMobile ? 1 : 2}>
        {cardsData?.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              {[1, 3, 4, 6].includes(card.id) ? (
                <SustainableImage data={card} />
              ) : card.id == 5 ? (
                <AnimatedTextCard
                  imageSrc={card.imageSrc}
                  title={card?.title}
                  description={card?.subTitle}
                />
              ) :
                <HoverImageCard imageSrc={card.imageSrc} title={card?.title} description={card?.subTitle} />
              }
            </Box>
          </Grid>

        ))}
      </Grid>




    </Container>
  );
}
